export default {
  computed: {
    uid() {
      return this._uid
    },
  }
}
